module.exports = __webpack_public_path__ + "img/visa.e15dc4dc.png";